import React from 'react'
import {motion} from "framer-motion";
import { AppWrap, MotionWrap } from '../../wrapper';
import ReactToolTip from 'react-tooltip';
import './About.scss';
import { useState } from 'react';

const educations = [
  {
    year: '2020', course: "Bsc, Computer Science", school: "ESAE University", desc:"15th Sept 2017 - 20th Oct 2020"
  }
]
const About = () => {

  const [education] = useState(educations)

  return (
   <>
    {/* <h2 className='head-text'>
     About me
    </h2> */}
    <div className='about-card'>
      <div className='about'>
    <h2 style= {{color: "#ffffff"}}>
     About
    </h2>
      <p>Hello! I am Muhammad Kabiru Suleiman. <br/>A Software Engineer with 6 years experience in Software Development and Project Management,
      I am adept in designing and developing applications as well as servers and database that make up the foundational structure of a website.
      <br />I am capable of ensuring quality and scalable responsiveness of an application and
      i am seeking to utilize acquired skills to contribute towards organizational growth and development.<b/>
    </p>
      </div>
      <div className='basic'>
        <h2 style= {{color: "#ffffff"}}>
          Basic Information</h2>
        
        <p><b>EMAIL:</b><span></span><span>brainbox.sb@gmail.com</span></p>
        <p><b>PHONE: </b><span></span>+2349066147431</p>
        <p><b>ADDRESS: </b> <span>Tunga Farm center, Minna, Niger State</span></p>
        <p><b>LANGUAGE:</b> <span style={{padding: "2px"}}>English</span></p>
      </div>
    </div>
    <div className='app__profiles'>
      {/* {abouts.map((about, index) =>  (
        <motion.div
        whileInView={{opacity: 1 }}
        whileHover = {{scale: 1.1}}
        transition= {{duration: 0.5, type: 'tween'}}
        className = "app__profile-item"
        key= {about.title + index}
        >
          <img src={about.imgUrl} alt={about.title}/>
          <h2 className='bold-text' style={{marginTop:20 }}>{about.title}</h2>
          <p className='p-text' style={{marginTop:10}} >{about.description}</p>
        </motion.div>
      ))} */}
      
    </div>
    <h2 className='head-text'>Education</h2>

      <motion.div className='app__skills-edu'>
                {education.map((education)=> (
                        <motion.div
                        className='app__skills-edu-item'
                        key={education.year}
                        >
                            <div className='app__skills-edu-year'>
                            <p className='bold-text'>{education.year}</p>
                            </div>
                            <motion.div className='app__skills-edu-works'>
                            {/* {experience.works.map((work) => ( */}
                            <>
                            <motion.div
                            whileInView = {{opacity: [0,1]}}
                            transition = {{duration: 0.5}}
                            className = "app__skills-edu-work"
                            data-tip
                            data-for = {education.course}
                            key={education.course}
                            >
                            <h4 className='bold-text'>{education.course}</h4>
                            <p className='p-text'>{education.school}</p>
                        </motion.div>
                        <ReactToolTip
                            id={education.course}
                            effect ='solid'
                            arrowColor='#fff'
                            className='skills-tooltip'
                            >
                            {education.desc}
                            </ReactToolTip>
                            </>
                            {/* ))} */}
                        </motion.div>
                    </motion.div>
                    ))}
           </motion.div>
  
   </>
  )
}

export default AppWrap(
  MotionWrap(About, 'app__about'), 
  'about')